import React, { Component } from 'react';
import { Collapse } from 'react-collapse';

const Product = (props) => {
  let redStyle = {
    'borderColor': 'red',
    'maxWidth': '90px'
  }
  let normalStyle = {
    'borderColor': 'rgb(233, 235, 236)',
    'maxWidth': '90px'
  }
  return(
    <tr>
      <td className="hidden-xxs-down">
        {props.index+1}
      </td>
      <td>
        {props.product.item.name}
      </td>
      <td>
        <div className="d-flex justify-content-start align-items-center">
          <div>
            <input type="number" className="form-control" value={props.product.amount} min={1}
              disabled={props.product.amount_auto_calculated}
              onChange={(event)=>props.onAmountChange(event,props.index)} style={(props.productError.indexOf(props.index) !== -1 || props.product.amount < 0)? redStyle : normalStyle}
              onBlur={()=>props.onAmountBlur(props.index)}/>
          </div>
          <div className="ml-1 hidden-xxs-down">
            <span className="badge badge-pill badge-info">{props.product.item.measure_unit? props.product.item.measure_unit : 'kg'}</span>
          </div>
        </div>
      </td>
      <td>
        <div className="row">
          <div className="col-sm-8">
            <input type="number" className="form-control" value={props.product.pieces} min={1}
              disabled={props.product.pieces_auto_calculated}
              onChange={(event)=>props.onPiecesChange(event,props.index)} style={(props.piecesProductError.indexOf(props.index) !== -1 || props.product.pieces < 0)? redStyle : normalStyle}
              onBlur={()=>props.onPiecesBlur(props.index)}/>
          </div>
        </div>
      </td>
      <td className="d-flex">
        <span className="btn btn-danger btn-sm" onClick={() => props.onProductDelete(props.index)}><i className="fa fa-trash"></i></span>
        {!props.product.amount_auto_calculated &&
          <span className="btn btn-info btn-sm" onClick={() => props.onAmountBlur(props.index, true)}>
            <i className="fa fa-balance-scale"></i>
          </span>}
      </td>
    </tr>
  )
}

export default class ListProducts extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpened: true }
    this.toggleCollapse = this.toggleCollapse.bind(this);
  }

  toggleCollapse(){
    this.setState({isOpened: !this.state.isOpened});
  }

  render(){
    let borderTop={borderTop: "1px solid #dbdee0"}
    return(
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center pointer" onClick={this.toggleCollapse}>
          <div className="d-flex">
            <h5 className="mr-05 mb-0">{this.props.title}</h5>
            {this.state.isOpened ? null : <span> ({this.props.products.length})</span> }
          </div>
          <i className={`fa ${this.state.isOpened ? "fa-caret-up" : "fa-caret-down"}`}></i>
        </div>
        <Collapse isOpened={this.state.isOpened}>
          <div className="card-block p-0 m-0">
            {this.props.products.length ?
              <table className="table table-striped table-hover mb-0">
                <thead>
                  <tr>
                    <th className="hidden-xxs-down">-</th>
                    <th>Item</th>
                    <th className="hidden-xs-down">Quantity</th><th className="hidden-sm-up">Qty</th>
                    <th className="hidden-xs-down">Pieces</th><th className="hidden-sm-up">Pcs</th>
                    <th className="hidden-xs-down">Actions</th><th className="hidden-sm-up">-</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.products.map((product,index)=>{
                    return(
                      <Product
                        product={product}
                        onAmountChange={this.props.onAmountChange}
                        productError={this.props.productError}
                        onAmountBlur={this.props.onAmountBlur}
                        onProductDelete={this.props.onProductDelete}
                        onPiecesChange={this.props.onPiecesChange}
                        onPiecesBlur={this.props.onPiecesBlur}
                        piecesProductError={this.props.piecesProductError}
                        index={index}
                        key={index}
                      />
                    )
                  })}
                </tbody>
              </table>
            :
              <div className="empty-table"><span>No products yet</span></div>
            }

          </div>
          <div className="card-header" style={borderTop}>
            <h6 className="mb-0">Number of products: {this.props.products.length}</h6>
          </div>
        </Collapse>
      </div>
    )
  }
}
